<script setup>
import { defineProps, computed } from 'vue';

// Vue Components
import HeaderLogo from '../svg/HeaderLogo.vue';
import IconInstagram from '../svg/IconInstagram.vue';

// Functions
import popObjFromSiteMap from '../functions/popObjFromSiteMap.js';

const props = defineProps({
    siteMap: {
        type: Object,
        default: {}
    },
    snsList: {
        type: Object,
        default: {}
    },
    information: {
        type: Object,
        default: {}
    },
    colors: {
        type: Object,
        default: {}
    },
    pageId: {
        type: String,
        default: ''
    },
});

// SNSアイコンとSVGの対応付け
const snsIconsMap = {
    instagram: IconInstagram
}

// グロナビ
const gnavList = computed(() => {
    const keys = ['story', 'news', 'stay', 'toka', 'facility', 'location'];
    return popObjFromSiteMap(keys, props.siteMap);
});

// フッターボタン
const footBtnList = computed(() => {
    const keys = ['faq', 'contact'];
    return popObjFromSiteMap(keys, props.siteMap);
});
</script>

<template>
<footer :class="`footer is-${pageId}`">
	<div class="inner">
        <p class="footer__logo">
            <a href="/"><HeaderLogo/></a>
        </p>
        <nav class="footer__nav">
            <ul class="footer__list">
                <li class="footer__item" :class="{'is-current': pageId === key}" v-for="val, key in gnavList">
                    <a :href="val.url">{{ val.name }}</a>
                </li>
            </ul>
            <ul class="footer__sns-list">
                <li class="footer__sns-item is-instagram" v-for="val, key in snsList" :key="key">
                    <a :href="val.url" target="_blank">
                        <component :is="snsIconsMap[key]"/>
                    </a>
                </li>
            </ul>
        </nav>
        <div class="footer__information">
            <address class="footer__address">
                {{ information.zipCode }} <br class="md-none">{{ information.address }}
            </address>
            <span class="footer__tel">
                FAX {{ information.fax }}
            </span>
        </div>
        <div class="footer__btn-area">
            <a :href="val.url" class="btn is-footer is-transparent-b" v-for="val, key in footBtnList" :key="key">
                <span class="btn__en">{{ val.name }}</span>
                <span class="btn__ja">{{ val.nameJa }}</span>
                <span class="arrow btn__arrow"></span>
            </a>
        </div>
        <nav class="footer__nav-sub">
            <ul class="footer__sub-list">
                <li class="footer__sub-item">
                    <a href="https://bluesky-as.com/disclaimer/" target="_blank">利用規約</a>
                </li>
                <li class="footer__sub-item">
                    <a href="https://bluesky-as.com/privacy/" target="_blank">プライバシーポリシー</a>
                </li>
                <li class="footer__sub-item">
                    <a href="https://bluesky-as.com/" target="_blank">運営会社</a>
                </li>
            </ul>
            <div class="footer__copyright">
                <small>Copyright Blue Sky Associates Co., Ltd. All Rights Reserved.</small>
            </div>
        </nav>
	</div>
</footer>
</template>